<template>
	<div>
		<div class="plugin-content">
			<section class="container-1200 se11" style="width:100%;margin: 0px auto;">
				<div class="first">
					<div class="first_left">
						<img :src="require('@/assets/images/works_left.png')" alt="">
					</div>
					<div class="first_right">
						<h2>What’s the Contrimetric’s plug-in?</h2>
						<p style="margin-top: 15px;text-align: justify; hyphens: auto;font-size:16px;" lang="en">
							The Contrimetric plug-in is an AI-powered academic enhancement tool designed to transform how
							researchers, publishers, and institutions interact with citations, discover content, and
							showcase research impact all in real time.

						<div style="margin: 4px 0;"></div>
						It’s more than a widget. It’s a citation-aware, context-driven, discovery-enhancing engine for
						the modern research ecosystem.
						</p>
					</div>
				</div>

				<WorkAround></WorkAround>
			</section>
		</div>

		<div class="plugin-second-ele">
			<SecondThree></SecondThree>
		</div>
	

		<div class="plugin-third-ele">
			<ThirdThree></ThirdThree>
		</div>
		<div class="plugin-fourth-ele">
			<div class="container-1200 se14">
				<div class="title">Learn more about Contrimetric Plugin</div>
				<div class="video-container">
					<div v-if="!isPlaying" class="cover" @click="playVideo">
						<img :src="coverImage" alt="video cover" class="cover-image" />
						<span class="play-icon">▶</span>
					</div>

					<video v-if="isPlaying" ref="videoPlayer" :src="videoSrc" class="video-player" @ended="onVideoEnded"
						controls>
						<source type="video/mp4" />
						Your browser does not support the video tag.
					</video>

					<div v-if="!isPlaying" class="video-info">
						02:26
					</div>
				</div>
			</div>
		</div>
		<div class="last-ele">
			<section class="container-1200 se13">
				<div class="worksBottom" style="margin-top: 100px;">
					<img :src="require('@/assets/images/index_widget.png')" alt="" />
				</div>
			</section>
		</div>

	</div>
</template>
<script>
import SecondThree from "./secondThree.vue";
import WorkAround from "./workAround.vue";
import WorkGrid from "./workGrid.vue";
import videoCover from "@/assets/images/logo_slogan_.png"
import ThirdThree from "./thirdThree.vue";

export default {
	name: "works",
	components: {
		SecondThree,
		WorkAround,
		WorkGrid,
		ThirdThree
	},
	data() {
		return {
			isPlaying: false,
			videoSrc: "/cstatic/contrimetric/public.mp4",
			coverImage: videoCover,
		};
	},
	watch: {},
	created() {

	},
	mounted() { },
	methods: {
		playVideo() {
			this.isPlaying = true;
			this.$nextTick(() => {
				this.$refs.videoPlayer.play();
			});
		},
		onVideoEnded() {
			this.isPlaying = false;
		},
	},
}
</script>

<style lang="scss" scoped>
.plugin-content {
	width: 100%;
	padding-bottom: 20px;
	background-color: #F6FAFC;
}

.first {
	display: flex;
	align-items: center;
}

.first_left {
	flex: 1;
}

.first_left img {
	width: 75%;
}

.first_right {
	flex: 1;
	margin-top: 50px;
	line-height: 26px;
}

.second {
	display: flex;
	position: relative;
}

.second_left {
	width: 42%;
	line-height: 26px;
	border: 2px dotted hsl(183.72deg, 77.54%, 63.33%);
	padding: 30px 20px 30px 30px;
}

li {
	list-style-type: disc;
}

ul li::marker {
	color: hsl(183.72deg, 77.54%, 63.33%);
	/* 设置列表项圆圈的颜色为红色 */
}

.second_right {
	width: 42%;
	line-height: 26px;
	border: 2px dotted hsl(183.72deg, 77.54%, 63.33%);
	padding: 30px 20px 30px 30px;
	margin-left: 30px;
	position: absolute;
	right: 115px;
	top: 230px;
	margin-bottom: 100px;
}

.worksBottom img {
	width: 100%
}

.se11 {
	h2 {
		font-size: 30px;
	}
}

.se12 {
	h2 {
		margin: 10px 0px;
		font-size: 30px;
	}

	margin: 40px auto;
	margin-top: 80px;
}

.se13 {
	box-sizing: border-box;
	width: 100%;
	margin: 20px auto;
}

.last-ele {
	width: 100%;
	padding: 60px 0;
	width: 100%;
	background-color: #F6FAFC;

}

.plugin-second-ele,
.plugin-fourth-ele {
	width: 100%;
	background-repeat: no-repeat;
	background-size: 100% 100%;
}

.plugin-second-ele {
	padding: 80px 0;
	background-image: url('../../assets/images/services/second_three_bg.png');
}

.plugin-fourth-ele {
	padding: 20px 0;
	background-image: url('../../assets/images/services/fourthBg.png');
}

.plugin-third-ele{
	width: 100%;
	padding: 60px 0;
	background: #F6FAFC;
}

.se14 {
	margin:50px auto;
	margin-bottom: 100px;

	.title {
		color: #fff;
		font-size: 30px;
		font-weight: bold;
		text-align: center;
		margin-bottom: 50px;
	}

	.video-container {
		width: 100%;
		position: relative;
		background-color: #fff;

		.cover {
			position: relative;
			cursor: pointer;
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 650px;
			transition: all .3s;
			padding: 80px;
			box-sizing: border-box;

			&:hover {
				cursor: pointer;
				opacity: 0.7;

				.play-icon {
					transform: scale(1.05);
				}
			}

			img {
				width: 100%;
				object-fit: contain;
			}
		}

		.cover-image {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		.play-icon {
			position: absolute;
			font-size: 30px;
			color: white;
			z-index: 9;
			background-color: #00000087;
			padding: 10px;
			border-radius: 50%;
			width: 70px;
			height: 70px;
			box-sizing: border-box;
			display: flex;
			justify-content: center;
			align-items: center;
			transition: all .3s;
		}

		.video-player {
			width: 100%;
			height: auto;
			transform: translateZ(0);
		}

		.video-info {
			position: absolute;
			background: linear-gradient(to bottom, rgb(255 255 255 / 0%), rgb(0 0 0 / 55%));
			width: 100%;
			height: 60px;
			color: white;
			bottom: 0;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			padding-right: 20px;
			box-sizing: border-box;
		}
	}
}

@media (max-width: 768px) {
	.se11 {
		box-sizing: border-box;
	}

	.first {
		flex-direction: column-reverse;

		.first_left {
			margin-top: 20px;
			text-align: center;

			img {
				width: 60%;
			}
		}

		.first_right {
			margin-top: 30px;
			padding: 0 20px;

			h2 {
				font-size: 24px;
			}
		}
	}

	.se12 {
		height: auto;
		margin-top: 50px;
	}

	.second {
		flex-direction: column;

		.second_left {
			width: 100%;
			box-sizing: border-box;
			padding: 30px;

			h2 {
				font-size: 24px !important;
			}
		}

		.second_right {
			margin-top: 20px;
			position: static;
			width: 100%;
			margin-left: 0;
			box-sizing: border-box;
			margin-bottom: 20px;

			h2 {
				font-size: 24px !important;
			}
		}
	}

	.worksBottom {
		margin-top: 30px !important;
	}
}</style>